export enum Season {
  None = 'N/A',
  Winter = 'Winter',
  Summer = 'Summer',
}

export enum SeasonId {
  NotAvailable = 1,
  Winter = 2,
  Summer = 3
}

export enum PSO {
  Peak = 'Peak',
  Standard = 'Standard',
  OffPeak = 'Off-Peak',
}

export enum PSOShort {
  Peak = 'P',
  Standard = 'S',
  OffPeak = 'O',
}


export enum Days {
  Weekdays = 'Weekdays',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
}

export enum ChargeName {
  Energy = 'Energy Charge',
  Basic = 'Basic Charge',
  Demand = 'Demand Charge',
  Access = 'Access Charge',
  Service = 'Service Charge',
  Capacity = 'Capacity Charge',
  Reactive = 'Reactive Charge',
  Legacy = 'Legacy Charge',
  NetworkDemand = 'Network Demand Charge',
  Generation = 'Generation Charge',
  Electrification = 'Electrification Charge',
  Affordability = 'Affordability Charge',
  Ancillary = 'Ancillary Charge',
  CreditRev = 'Credit Reverse Charge',
  FixedMonthly = 'Fixed Monthly Charge',
  FixedDaily = 'Fixed Daily Charge',
  NetworkSurcharge = 'Network Surcharge',
  Subsidy = 'Subsidy Charge',
  ReactiveService = 'Reactive Service Charge',
  AdditionalEnergy = 'Additional Energy Charge',
}


